"use client";

import React, { useMemo } from "react";
import { cn } from "@/lib/utils";
import { Carousel, CarouselContent, CarouselItem } from "@/shadcn/ui/carousel";
import AutoScroll from "embla-carousel-auto-scroll";

export default function ChipScrollingBanner({
  texts,
  speed,
  direction,
  className = "",
}: {
  texts: string[];
  speed: "slow" | "fast";
  direction: "forward" | "backward";
  className?: string;
}) {
  const autoScroll = useMemo(
    () =>
      AutoScroll({
        speed: speed === "slow" ? 1 : 3,
        startDelay: 0,
        stopOnInteraction: false,
        direction: direction,
      }),
    [speed, direction],
  );

  const items = [...texts, ...texts].map((item, i) => (
    <CarouselItem
      key={i}
      className="flex items-center flex-shrink-0 px-[3rem] py-[1.5rem] bg-[#D9F9B9]/[0.12] rounded-full backdrop-blur-[3.5rem] ml-[1rem]"
    >
      <p className="text-[2rem] mb-0 leading-[150%] font-geist uppercase whitespace-nowrap select-none">
        {item}
      </p>
    </CarouselItem>
  ));

  return (
    <div className="relative w-full">
      <Carousel
        opts={{ loop: true }}
        plugins={[autoScroll]}
        className={cn(
          "relative overflow-clip text-[#D9F9B9] w-full",
          className,
        )}
      >
        <CarouselContent>{items}</CarouselContent>
      </Carousel>
    </div>
  );
}
